// extracted by mini-css-extract-plugin
module.exports = {"box":"_Home_box_3YShp","title":"_Home_title_uCk6g","box-form":"_Home_box-form_19u2F"};